import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { usePendingPods } from 'hooks/usePendingPods/usePendingPods';
import { useTranslation } from 'react-i18next';
import Spinner from 'components/Spinner';
import JourneysList from 'components/JourneysList';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';

const PendingPods = ({ className }) => {
  const {
    pendingPodsJourneys,
    error,
    loading,
    setViewedJourneys
  } = usePendingPods();
  const { t } = useTranslation('Jobs');
  let history = useHistory();

  useEffect(() => {
    setViewedJourneys();
  }, [setViewedJourneys]);

  const handleClick = useCallback(
    id =>
      history.push({
        pathname: `${ROUTES.PENDING_PODS_DETAIL.DEFAULT}/${id}`,
        state: { backRoute: ROUTES.PENDING_PODS }
      }),
    [history]
  );

  const renderPendingPods = useCallback(() => {
    if (loading) {
      return (
        <div className="pending-pods__loading" data-testid="loading">
          <Spinner />
        </div>
      );
    }

    if (error) {
      return <div data-testid="error">{t('error')}</div>;
    }

    if (!pendingPodsJourneys || pendingPodsJourneys.length === 0) {
      return (
        <div className="pending-pods__alert" data-testid="no-pending-pods">
          {t('noPendingPod')}
        </div>
      );
    }

    return (
      <JourneysList
        journeys={pendingPodsJourneys}
        parentClass="pending-pods"
        handleClick={handleClick}
      />
    );
  }, [error, loading, pendingPodsJourneys, t, handleClick]);

  return (
    <div className={className} data-testid="root">
      <div className="pending-pods">
        <div className="pending-pods__container">{renderPendingPods()}</div>
      </div>
    </div>
  );
};

PendingPods.propTypes = {
  className: PropTypes.string
};
export default PendingPods;
